var BaseAuthenticationClient = /** @class */ (function () {
    function BaseAuthenticationClient(options) {
        this.options = options;
    }
    Object.defineProperty(BaseAuthenticationClient.prototype, "appHost", {
        get: function () {
            var _a = this.options, appHost = _a.appHost, domain = _a.domain, host = _a.host;
            // 最新版本，传入 appHost
            if (appHost) {
                return appHost.replace(/\/$/, '');
            }
            // 兼容协议认证 API 中传入的 domain
            else if (domain) {
                var hostUrl = new URL(this.options.host);
                return "".concat(hostUrl.protocol, "//").concat(this.options.domain);
            }
            // 最后使用服务器统一域名 host
            else {
                return host;
            }
        },
        enumerable: false,
        configurable: true
    });
    return BaseAuthenticationClient;
}());
export { BaseAuthenticationClient };
//# sourceMappingURL=BaseAuthenticationClient.js.map